import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import { useSelector } from 'react-redux';
import {RootState} from "../redux/reduxTypes";

interface PrivateRouteProps {
    roles: string[];           // '-', '*', or specific role names
    children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ roles, children }) => {
    const { userid, groups = [] } = useSelector((s: RootState) => s.user);
    const path = useLocation().pathname;

    const isAuthed = Boolean(userid) && groups.length > 0;
    const wantsUnauthedOnly = roles.includes("-");  // pages like /auth/login
    const wantsAnyAuthed   = roles.includes("*");
    const hasRequiredRole  = roles.some((r) => groups.includes(r));

    // 1) Routes intended for UNAUTHENTICATED users only
    if (wantsUnauthedOnly) {
        if (!isAuthed) return <>{children}</>;                 // unauthenticated may enter
        return path === "/home" ? null : <Navigate to="/home" replace />; // authed not allowed
    }

    // 2) Routes that REQUIRE authentication
    if (!isAuthed) {
        return path === "/auth/login" ? null : <Navigate to="/auth/login" replace />;
    }

    // 3) Authenticated: role checks
    if (wantsAnyAuthed || hasRequiredRole) {
        return <>{children}</>;                                // authorized
    }

    // 4) Authenticated but not permitted
    return path === "/home" ? null : <Navigate to="/home" replace />;
};

export default PrivateRoute;